import { evaluatePassword } from '@l2u/shared/password';
import { NavIcon } from '@l2u/ui/components/NavIcon.tsx';

// Live checklist for the password composition rules. Renders nothing until the
// user starts typing. Met/unmet state is carried in text (sr-only prefix), not
// color alone, and the list is aria-live so a screen reader announces rules as
// they are satisfied. Single source of truth: @l2u/shared/password.
export function PasswordRequirements({
  password,
  className = '',
}: {
  password: string;
  className?: string;
}) {
  if (!password) return null;
  const results = evaluatePassword(password);
  return (
    <ul aria-live="polite" className={`mt-2 space-y-1 ${className}`}>
      {results.map((rule) => (
        <li
          key={rule.id}
          className={`flex items-center gap-2 text-xs ${
            rule.met ? 'text-green-700' : 'text-slate-500'
          }`}
        >
          <span
            aria-hidden
            className="flex h-3.5 w-3.5 items-center justify-center text-green-600"
          >
            {rule.met ? (
              <NavIcon name="check-circle" size={14} />
            ) : (
              <span className="inline-block h-3 w-3 rounded-full border border-slate-300" />
            )}
          </span>
          <span>
            <span className="sr-only">{rule.met ? 'Met: ' : 'Not met: '}</span>
            {rule.label}
          </span>
        </li>
      ))}
    </ul>
  );
}
